import React from 'react';

const CLASS_PREFIX = 'mission-card';

/**
 * CardBadges Component
 * 
 * Renders status badges at the top of the card:
 * - Blocked indicator (when task is blocked)
 * - Archived badge (when task is archived)
 */
const CardBadges = ({
  task,
  isBlocked = false,
  showBlockedIndicator = true,
}) => {
  return (
    <>
      {/* Blocked indicator tag */}
      {showBlockedIndicator && isBlocked && (
        <div className={`${CLASS_PREFIX}__blocked-tag`} title={task.blockedReason || 'No reason provided'}>
          <span className={`${CLASS_PREFIX}__blocked-icon`}>🚫</span>
          BLOCKED
        </div>
      )}
      
      {/* Archived badge */}
      {task.archived && (
        <div className={`${CLASS_PREFIX}__archived-badge`} title={`Archived ${task.archivedAt ? `on ${new Date(task.archivedAt).toLocaleDateString()}` : ''}`}>
          <span className={`${CLASS_PREFIX}__archived-icon`}>📦</span>
          ARCHIVED
        </div>
      )}
    </>
  );
};

export default CardBadges;
